import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = [
        { name: 'Plate', path: '/plate', icon: 'fas fa-wallet' },
        { name: 'Dnevnice', path: '/dnevnice', icon: 'fas fa-calendar-day' },
        { name: 'LED ekrani', path: '/led-ekrani', icon: 'fas fa-tv' },
        { name: 'Fakture', path: '/sef-upload', icon: 'fas fa-file-upload' },
        { name: 'Kalkulator', path: '/kalkulator', icon: 'fas fa-calculator' },
        { name: 'Radnici', path: '/radnici', icon: 'fas fa-users' },
        { name: 'Vozila', path: '/vozila', icon: 'fas fa-car' },
        { name: 'Download', path: '/download', icon: 'fas fa-download' },
        { name: 'Korisnici', path: '/korisnici', icon: 'fas fa-user-shield' },
        { name: 'Settings', path: '/settings', icon: 'fas fa-cog' },
    ];

    const sidebarStyle = {
        width: '250px',
        backgroundColor: '#0a132b',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRight: '1px solid #1a2a4a'
    };

    const itemStyle = (path) => ({
        padding: '15px 25px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        color: location.pathname === path ? '#3366ff' : 'white',
        backgroundColor: location.pathname === path ? '#162447' : 'transparent',
        transition: '0.3s',
        borderBottom: '1px solid #1a2a4a'
    });

    const iconStyle = (path) => ({
        width: '20px',
        color: location.pathname === path ? 'white' : '#3366ff',
        fontSize: '18px'
    });

    return (
        <div style={sidebarStyle}>
            <nav style={{ flex: 1, paddingTop: '10px' }}>
                {menuItems.map((item) => (
                    <div 
                        key={item.path}
                        onClick={() => navigate(item.path)}
                        style={itemStyle(item.path)}
                        onMouseEnter={(e) => {
                            if (location.pathname !== item.path) {
                                e.currentTarget.style.backgroundColor = '#162447';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (location.pathname !== item.path) {
                                e.currentTarget.style.backgroundColor = 'transparent';
                            }
                        }}
                    >
                        <i className={item.icon} style={iconStyle(item.path)}></i>
                        <span style={{ fontWeight: '500' }}>{item.name}</span>
                    </div>
                ))}
            </nav>
        </div>
    );
};

export default Sidebar;